var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-cell-box"},[_vm._t("default",null,{"cell":_vm.data,"index":_vm.index})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }